import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { ADMIN_DASHBOARD_API_PATHS } from '../constants/statistics-api-paths.constant';
import { SalesComparison } from '../types/sales-comparison.type';

interface GetSalesComparisonResponse {
  status: string;
  data: SalesComparison;
}

type UseGetSalesComparisonResult = {
  isLoading: boolean;
  salesComparison: SalesComparison | null;
};

export function useGetSalesComparison(): UseGetSalesComparisonResult {
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState<UseGetSalesComparisonResult>({ isLoading: true, salesComparison: null });

  useEffect(() => {
    let cancelled = false;

    HttpClient.get<GetSalesComparisonResponse>(ADMIN_DASHBOARD_API_PATHS.GET_SALES_COMPARISON)
      .then((response) => {
        if (!cancelled) setState({ isLoading: false, salesComparison: response.data });
      })
      .catch((error) => {
        if (!cancelled) {
          enqueueSnackbar(
            extractApiErrorMessage(error, 'Erreur lors de la récupération des statistiques'),
            { variant: 'error' }
          );
          setState({ isLoading: false, salesComparison: null });
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
